import React, { useState } from 'react'
import { ICarouselProps } from './cities-carousel-props.interface'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Keyboard, Swiper as SwiperClass } from 'swiper'
import './cities-carousel.scss'
import three_bars from 'theme/images/three-bars.svg'
import button_freccia_dx from 'theme/images/button_freccia_dx.svg'
import { IonCol, IonIcon, IonRouterLink, IonRow } from '@ionic/react'
import { BREAKPOINTS } from '../../interfaces/utils.interface'
import { routeService } from 'services'
import { Link } from 'react-router-dom'

const CitiesCarousel: React.FC<ICarouselProps> = ({ items, header }) => {
  const [swiper, setSwiper] = useState<SwiperClass>()
  return (
    <IonRow className="edisu-cities-carousel">
      {header && (
        <IonCol size="12" className="header-cnt">
          {header}
        </IonCol>
      )}
      <IonCol size="12" sizeLg="8">
        <Swiper
          onSwiper={(swiper) => setSwiper(swiper)}
          loop
          keyboard
          modules={[Keyboard]}
          slidesPerView={1}
          slidesPerGroup={1}
          spaceBetween={15}
          breakpoints={{
            [BREAKPOINTS.xl]: {
              slidesPerView: 2,
            },
            [BREAKPOINTS.lg]: {
              slidesPerView: 1.5,
            },
          }}
        >
          {items.map((item) => (
            <SwiperSlide key={item.id}>
              <Link to={routeService.generateRoutePath('/residences') + '?c=' + item.id}>
                <div className="cities-carousel-item">
                  <div className="opacity-hover" />
                  <img src={item.image} className="carousel-img" alt={item.text} />
                  <div className="carousel-box-content">
                    <span className="text">{item.text}</span>
                    <img src={three_bars} alt="" />
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </IonCol>
      {swiper && (
        <IonCol size="12" sizeLg="4" className={'next-cnt ion-hide-lg-down'}>
          <IonIcon src={button_freccia_dx} onClick={() => swiper.slideNext()} className="circle-arrow-btn" />
        </IonCol>
      )}
    </IonRow>
  )
}

export default CitiesCarousel
